// extracted by mini-css-extract-plugin
export default {"gridForm":"BusinessIdForm_gridForm__q+yzc","twoCol":"BusinessIdForm_twoCol__kMMPw"};